export default __webpack_public_path__ + "static/B0008-3a8a10bb2fc2c3fad11ecd7af8e5b0b7.png";